import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * app专用接口
 **********************************************************************************/
export default {
	/**
	 * 获取apk版本号
	 */
	getNowVersionByAppTag: (appTag,success, failure) => {
		Axios.post('/app/getNowVersionByAppTag.do', {
			appTag
		}, success, failure);
	}

}
